import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 693854 652809"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:7654.46}.fil0{fill:#1c1b17}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974618695264">
        <path
          d="M315280 360383c-342-8268-4380-14516-5003-25224-743-12657 2531-18373 3355-28619-5133-4500-7544-8227-12396-12396-11803-10185-33440-30447-50115-28950-29071 2592-62944 7835-91914 12476-35801 5766-97750 15711-131100 27303-10869 3777-33682 11492-20061 23878 22411 20391 121055 43526 158132 53581 13411 3636 74445 19407 85013 19367 15239-30 51221-28599 64089-41416zM570569 648430c19759-27334-53320-251714-57298-256053-10216-11140-51341-32366-74636-32406-3817 12124-19849 27172-31783 32315-11341 4882-9352 4772-11924 19217-1627 9181-2662 20502-2973 30065-703 21838 2963 17861 21195 43114 18252 25274 39508 48951 57369 72607 3957 5254 10316 12476 14455 16886 15489 16484 28699 33551 46208 50940 7152 7102 28066 27483 39387 23315zM433683 294928c18272-2471 43656-18564 57830-29533 7685-5937 6560-10407 9302-20281 15580-55982 36585-131312 44681-188941 8810-62682-2571-64460-37639-29784-15149 14957-39076 45475-53310 62642-8418 10146-16957 22029-25134 32858-8428 11160-16876 22200-25143 34395-8378 12345-33179 39407-32747 53430 311 9945 3857 42210 7956 50186 2953 5746 15148 5746 21737 8067 13180 4640 28027 16333 32467 26961z"
          className="fill stroke1"
          style={{
            strokeWidth: 7654.46,
          }}
        />
        <path
          d="M370649 276806c-74275 10498-55590 120885 15751 108941 71220-11924 54817-118916-15751-108941zM598515 302000c4651-4460 10246-14777 14214-20292 4590-6429 8749-14183 13752-19990 10638 30970 12697 78966 6620 113682-4290 24460-22632 78845-35330 92055 2994 2089 6218 4490 10397 5876 15128-17679 32929-70146 37238-97840 3375-21698 3586-40945 2551-63386-1044-22551-6660-36775-9774-56374l48720 3114c-2140-3636 50-642-2341-3154l-69955-61848c-6067-5113-20060-19076-25324-21557l9232 129714zM144049 467957c13591 27785 45997 61507 67383 77439 14947 11140 27634 18855 44430 27644 21025 11010 44139 16585 51914 20553l-27564 39678c3656 402 113742-33922 125455-38754-11030-7283-67525-34566-86470-44059-8779-4409-21878-12144-30256-14646l20834 44380c-51251-11481-91382-41105-126229-77418-5987-6228-24269-30056-27875-39599-6168 1588-6027 3155-11622 4782zM191442 134204c-3747-3787-16665-35600-20141-43857-3465 4600-7453 24480-8960 30638-4561 18603-22903 87122-23255 95741 6881-5133 18453-11381 26952-16746l84590-52235c-8448-1597-42169-1768-48046-7072 27946-22591 57178-43365 94867-55208 10849-3406 33360-7052 41196-10427l-623-9423c-2491-1285-1005-1145-5153-1285-15410-523-65425 19156-76876 25083-27303 14153-46188 28428-64551 44791z"
          className="fill stroke1"
          style={{
            strokeWidth: 7654.46,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
